import { TR, DIV, TD } from '../elements';

export interface NotNullProperties {
    [key: string]: any;
}

export const elementFactoryRow = (asTableRow: boolean) =>
    asTableRow ? TR : DIV;
export const elementFactoryCell = (asTableRow: boolean) =>
    asTableRow ? TD : DIV;
